import React from 'react'
import { GoSearch, GoInfo } from "react-icons/go"
import { HiHome, HiUser } from "react-icons/hi"
import styles from '../components/Overlay.module.css'

export const InfoOverlayContent = () => {
    return (
        <>
            <h2>REgionalität toGO</h2>
            <p>
                Mit ReGo soll regionales und nachhaltiges Einkaufen (wieder)entdeckt werden.
                Egal ob Obst-Stand oder Hofladen, jeder kann zeigen „hey mich gibt’s auch“.
            </p>
            <div className={styles.explainNav}>
                <HiHome />
                <p>Hier kannst du alle registrierten Shops auf einer Karte erkunden</p>
                <GoSearch />
                <p>Hier kannst du nach bestimmten Shops oder Regionen suchen</p>
                <GoInfo />
                <p>Hier kannst du Aktuelles von den verschiedensten Shops erfahren und teilen</p>
                <HiUser />
                <p>Hier kannst du dich selbst registrieren oder deinen Shop verwalten</p>
            </div>
        </>
    )
}
